<template>
  <view class="file-wrap">
    <div class="box flex flex-a-c" @click="openFile">
      <view class="imgView">
        <van-image :src="require('@/assets/H5/play/pdf.png')"></van-image>
      </view>
      <view class="name van-multi-ellipsis--l2">{{ item.remark }}</view>
    </div>
  </view>
</template>

<script>
import { defineComponent, onMounted } from "vue";

export default defineComponent({
  props: {
    item: Object,
  },
  setup(props, { emit }) {
    onMounted(async () => {});
    const openFile = () => {
      emit("clickItem", props.item);
    };
    return {
      openFile,
    };
  },
});
</script>

<style lang="less" scoped>
.file-wrap {
  .box {
    background: #ffffff;
    margin-bottom: 16px;
    padding: 12px 20px;
    border-radius: 4px;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  }

  .imgView {
    margin-right: 12px;
    .van-image {
      width: 24px;
      height: 27px;
    }
  }

  .name {
    font-size: 14px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.65);
  }
}
</style>
